<div class="page-content" (window:resize)="onResize($event)">
    <section class="home-banner home-slider-first">
        <div id="Bannerslider" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <a (click)="onNavigate($event)">
                        <div class="img-fluid fade-in" [ngClass]="fadeOut" [ngStyle]="{'background-image':'url('+bgUrl+')',
    'background-size':'cover',
    ' background-position':'50% 50%',
    'background-repeat':'no-repeat'}">
                            <div class="row" style="padding-top: 14%;
    padding-bottom: 15%;">
                                <div *ngIf="bgImages.length>1" class="col-md-6 col-sm-6 arrow-icon">
                                    <span> <i class="sideArrows leftArrow"
                                            (click)="changesBg(-1,$event);$event.stopPropagation()" nz-icon
                                            nzType="left" nzTheme="outline"></i></span>
                                </div>
                                <div *ngIf="bgImages.length>1" class="col-md-6 col-sm-6 arrow-icon"
                                    style="text-align: right;">
                                    <i class="sideArrows rightArrow"
                                        (click)="changesBg(1,$event);$event.stopPropagation()" nz-icon nzType="right"
                                        nzTheme="outline"></i>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <section class="intro-section bg-lightgrey" style="padding-bottom: 20px;">
        <div class="container home-button">
            <div class="row no-gutters bg-white box-shadow-01 main_card">
                <div class="col-sm-12 col-md-3 col-lg-3 iconbox-border">
                    <div class="iconbox iconbox-style-3 home_tab_button" style="background-color: #b72847;">
                        <div class="iconbox-inner">
                            <div class="iconbox-contents">
                                <div class="iconbox-title">
                                    <h2 style="color: #fff;">
                                        <a href="https://indiaalliance.org/fellows-corner" style="color: #ffffff;">
                                            {{currentLabelsObj["Awardee’s Corner"]}}
                                        </a>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-----
                <div class="col-sm-12 col-md-3 col-lg-3 iconbox-border">
                    <div class="iconbox iconbox-style-3 home_tab_button">
                        <div class="iconbox-inner">
                            <div class="iconbox-contents">
                                <div class="iconbox-title">
                                    <h2>
                                        <a href="https://indiaalliance.org/news/india-alliance-covid-nineteen-resource-hub"
                                            style="color: #000000;"> {{currentLabelsObj['COVID-19 Resource Hub']}} </a>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                -->
                <div class="col-sm-12 col-md-3 col-lg-3 iconbox-border">
                    <div class="iconbox iconbox-style-3 home_tab_button">
                        <div class="iconbox-inner">
                            <div class="iconbox-contents">
                                <div class="iconbox-title">
                                    <h2>
                                        <a [routerLink]="['/recently-recommended-awardees']" style="color: #000000;">
                                            {{currentLabelsObj['Recent Awards']}} </a>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 iconbox-border">
                    <div class="iconbox iconbox-style-3 home_tab_button">
                        <div class="iconbox-inner">
                            <div class="iconbox-contents">
                                <div class="iconbox-title">
                                    <h2>
                                        <a [routerLink]="['/applicants','fellowships-at-a-glance']"
                                            style="color: #000000;"> {{currentLabelsObj["Applicant's Corner"]}} </a>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- new -->
                <div class="col-sm-12 col-md-3 col-lg-3 iconbox-border">
                    <div class="iconbox iconbox-style-3 home_tab_button">
                        <div class="iconbox-inner">
                            <div class="iconbox-contents">
                                <div class="iconbox-title">
                                    <h2>
                                        <a [routerLink]="['/funding-portfolio']"
                                        style="color: #000000;"> {{currentLabelsObj["Research Portfolio"]}} </a>

                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end -->
            </div>
        </div>
    </section>
    <section class="bg-lightgrey welcome-company margin_header">
        <div class="container">
            <div class="section-title mt-md-50">
                <h3 class="subheading skincolor res_head" style="color: #000;font-weight: 600">
                    {{currentLabelsObj['Stories of Science']}} </h3>
            </div>
            <div class="row">
                <div nz-row [nzGutter]="15">
                    <div nz-col nzXs="24" nzSm="24" nzMd="10" nzLg="10" nzXl="10">
                        <div nz-row [nzGutter]="16">
                            <div nz-col nzSpan="24">
                                <ng-container *ngFor="let item of homePageNews; let i=index">
                                    <div nz-row *ngIf="i==0" style="cursor: pointer;" (click)="newItemNavigate(item)"
                                        class="res_mainNews">
                                        <div nz-col [nzSpan]="24">
                                            <img style="width: 100%; transition: all .5s ease 0s;" class="mainImage"
                                                [src]="item.Image_Information.ImageOriginal" />
                                        </div>
                                        <div nz-col [nzSpan]="24" style="margin-top: 10px;">
                                            <div nz-col [nzSpan]="24">
                                                <span style="    font-size: 19px; font-weight: 500;color: #b72847;">
                                                    <a style="color: #b72847;"
                                                        [attr.href]="'https://www.indiaalliance.org/stories_of_science/'+item.Post_URL">
                                                        {{currentLabelsObj[item.Post_Title]}}
                                                    </a>
                                                    <!-- <a style="color: #b72847;"
                                                        [attr.href]="'https://www.indiaalliance.org/news/'+item.Post_URL">
                                                        {{currentLabelsObj[item.Post_Title]}}
                                                    </a> -->
                                                </span>
                                            </div>
                                            <div nz-col [nzSpan]="24"
                                                style="   padding-right: 10px;padding-bottom: 12px;text-overflow: ellipsis;overflow: hidden;margin-top: 10px;">
                                                <span>
                                                    <!-- {{currentLabelsObj[item.Post_Description] | slice:0:240}} -->
                                                    {{currentLabelsObj[item.Post_Description] | slice:0:300}}
                                                    <!-- {{item.Post_Description | slice:0:240}} -->
                                                </span>
                                                <!-- <div [innerHTML]="domeSanitzer.bypassSecurityTrustHtml(item.Post_Body )"></div> -->
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6" nzXl="6">
                        <div nz-row [nzGutter]="16" class="res_newsLite">
                            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                                <ng-container *ngFor="let item of homePageNews; let i=index;let isLast=last">
                                    <div [nzGutter]="8" nz-row class="smallneww" *ngIf="i>0" style="cursor: pointer;"
                                        (click)="newItemNavigate(item)">
                                        <div nz-col [nzSpan]="8">
                                            <img style="width: 100%;" [src]="item.Image_Information.ImageOriginal">
                                        </div>
                                        <div nz-col [nzSpan]="16">
                                            <div nz-col [nzSpan]="24">
                                                <span class="littleCardPostTiltle">
                                                    <a style="color: #000;"
                                                        [attr.href]="'https://www.indiaalliance.org/stories_of_science/'+item.Post_URL">
                                                        {{currentLabelsObj[item.Post_Title]}}
                                                    </a>
                                                    <!-- <a style="color: #000;"
                                                        [attr.href]="'https://www.indiaalliance.org/news/'+item.Post_URL">
                                                        {{currentLabelsObj[item.Post_Title]}}
                                                    </a> -->
                                                    <span *ngIf="item.Post_Title.length>62"></span> </span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr *ngIf="!isLast&&i>0"
                                        style="border-top: 1px solid #b9a9a9; margin-top: 10px;margin-bottom: 10px;">
                                </ng-container>
                            </div>
                        </div>
                        <p> <a href="https://www.indiaalliance.org/stories_of_science" style="color: #b72847;
                            float: right"> {{currentLabelsObj['More Stories']}} >></a></p>
                        <!-- <p> <a href="https://www.indiaalliance.org/news" style="color: #b72847;
                            float: right"> {{currentLabelsObj['More Stories']}} >></a></p> -->
                    </div>
                    <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
                        <div class="social-links-wrapper">
                            <ul class="social-icons">
                                <li>
                                    <a href="https://www.facebook.com/IndiaAlliance" target="_blank" class="tooltip-top"
                                        data-toggle="tooltip" data-placement="top" data-tooltip="Facebook"><i
                                            class="fa fa-facebook"></i></a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/India_Alliance" target="_blank" class="tooltip-top"
                                        data-toggle="tooltip" data-placement="top" data-tooltip="X">
                                        <img src="assets/images/twitter_x.svg" alt="Twitter X Logo" width="25"
                                            height="25" style="margin-top: -5px; margin-left: -1px;">
                                            <!-- <img src="assets/images/twitter_x.svg" class="img-responsive" /> -->
                                        <!-- <i class="fa-brands fa-x-twitter"></i> -->
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/user/WTDBTIndiaAlliance" target="_blank"
                                        class="tooltip-top" data-toggle="tooltip" data-placement="top"
                                        data-tooltip="Youtube"><i class="fa fa-youtube"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/in/indiaalliance" target="_blank"
                                        class="tooltip-top" data-toggle="tooltip" data-placement="top"
                                        data-tooltip="LinkedIn"><i class="fa fa-linkedin"></i></a>
                                </li>
                            </ul>
                        </div>
                        <div nz-col [nzSpan]="24">
                            <div class="cream ">
                                <h5 style="color: #000000A6;
                           font-weight: 600;"> {{currentLabelsObj['About']}} </h5>
                                <br>
                                <p style="color: #000000A6;"> {{currentLabelsObj['AboutDesc']}} <br><a
                                        routerLink="about-us/about-ia" style="color: #000000A6;
                     float: right">
                                        {{currentLabelsObj['More']}}
                                        ></a></p>
                            </div>
                        </div>
                        <!-- Dynamic Deadline Part Starts -->
                        <!-- <div style="margin-top: 10px;" nz-col [nzSpan]="24">
                            <div class="cream ">
                                <h5 style="color: #000000A6;
                                font-weight: 600;"> Competition Deadlines</h5>
                                <ng-container *ngFor="let item of deadLinesList; let i=index;let isLast=last">
                                    <div *ngIf="i<2"
                                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding event-wrapper ng-scope"
                                        style="color: #000000A6;    margin-top: 14px;">
                                        <div class="row">
                                            <div class="col-xs-3 col-sm-3 col-md-3" style="padding: 0;">
                                                <div class="event-time-wrapper">
                                                    <span class="event-month">{{item.Deadline_Date|date:'MMM'}}</span>
                                                    <span class="event-day">{{item.Deadline_Date|date:'dd'}}</span>
                                                    <span class="event-year">{{item.Deadline_Date|date:'yyyy'}}</span>
                                                </div>
                                            </div>
                                            <div class="col-xs-9 col-sm-9 col-md-9">
                                                <div class="event-content">
                                                    <div class="event-name">
                                                        <a routerLink="../new"
                                                            style="color: #000000A6;"><span>{{item.CategoryData.Fellowship_Type_Title}}</span></a>
                                                    </div>
                                                    <span class="event-time"
                                                        style="color: #000000A6;">{{item.CategoryData.Fellowship_Category_Title}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider *ngIf="i<1" style=" margin : 8px;border-top-color: #000000A6;">
                                    </mat-divider>
                                </ng-container>
                                <p> <a href="https://www.indiaalliance.org/fellowshipdeadlines" style="color: #000000A6;
                                float: right"> More ></a></p>
                            </div>
                        </div> -->
                        <!-- Dynamic Deadline Part Ends -->
                        <!-- Static Deadline Part Starts -->
                        <div style="margin-top: 10px;" nz-col [nzSpan]="24">
                            <div class="cream ">
                                <h5 style="color: #000000A6;
                                font-weight: 600;"> {{currentLabelsObj['Competition Deadlines']}}
                                </h5>
                                <ng-container>
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding event-wrapper ng-scope"
                                        style="color: #000000A6;    margin-top: 14px;">
                                        <div class="row">
                                            <div class="col-xs-3 col-sm-3 col-md-3" style="padding: 0;">
                                                <div class="event-time-wrapper">
                                                    <span class="event-month" style="text-align: center;">Ended</span>
                                                    <!--   <span class="event-month" style="text-align: center;">01</span>
                                                    <span class="event-month">May</span>
                                                    <span class="event-year">2023</span>-->
                                                </div>
                                            </div>
                                            <div class="col-xs-9 col-sm-9 col-md-9">
                                                <div class="event-content">
                                                    <div class="event-name">
                                                        <a routerLink="../new" style="color: #000000A6;"><span>
                                                                {{currentLabelsObj["Team Science Grant"]}}
                                                            </span></a>
                                                    </div>
                                                    <span class="event-time" style="color: #000000A6;">
                                                        Team Science Grant (TSG)
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-divider style="margin: 8px;border-top-color: #000000A6;">
                                    </mat-divider>
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding event-wrapper ng-scope"
                                        style="color: #000000A6; margin-top: 14px;">
                                        <div class="row">
                                            <div class="col-xs-3 col-sm-3 col-md-3" style="padding: 0;">
                                                <div class="event-time-wrapper">
                                                    <span class="event-month" style="text-align: center;">Ended</span>
                                                    <!--   <span class="event-month" style="text-align: center;">01</span>
                                                    <span class="event-month">MAY</span>
                                                    <span class="event-year">2023</span>-->
                                                </div>
                                            </div>
                                            <div class="col-xs-9 col-sm-9 col-md-9">
                                                <div class="event-content">
                                                    <div class="event-name">
                                                        <a routerLink="../new" style="color: #000000A6;"><span>
                                                                {{currentLabelsObj["Clinical / Public Health Research
                                                                Centres"]}}
                                                            </span></a>
                                                    </div>
                                                    <span class="event-time" style="color: #000000A6;">
                                                        Clinical / Public Health Research Centres (CRC)
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <p>
                                    <!-- <a href="https://www.indiaalliance.org/fellowshipdeadlines" style="color: #000000A6;
                                float: right"> {{currentLabelsObj["More"]}} ></a> -->
                                </p>
                            </div>
                        </div>
                        <!-- Static Deadline Part Ends -->
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="row" style=" margin-top: 5px;">
        <div class="col-md-8 offset-2">
            <hr>
        </div>
    </div>
    <!-- Post & Testimonial -->
    <section class="section-md ">
        <div class="container" style="margin-top: -15px;">
            <div class="row res-fellow">
                <br>
                <div class="col-md-7 col-lg-7 feature">
                    <div class="section-title res_h3">
                        <h3 class="subheading skincolor h3_fellow res_h3"
                            style="color: #000;font-weight: 600;margin: 21px 0;">
                            {{currentLabelsObj["Awardees"]}}
                        </h3>
                    </div>
                    <section class="customer-logos slider fellow-roundimg">
                        <div class="row">
                            <div class="col-md-4 col-lg-4" *ngFor="let item of fellowsList; let i=index">
                                <div class="slide1" (click)="onFellowDetail(item)" style="cursor: pointer;">
                                    <img [src]="item.Image_Information.Image900" class="img-responsive"
                                        style="width: 195px; height: 200px;   border-radius: 50%;  border: 1px whitesmoke;">
                                    <p><b>
                                            {{currentLabelsObj[item.Name]}}
                                        </b></p>
                                    <p>
                                        {{currentLabelsObj[item.Fellowship_Type_Title]}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section><br>
                    <div class="viewallbtn">
                        <div class="button_icon res_button" style="text-align: center;margin-top: 16px;">
                            <button nz-button nzType="primary" [nzSize]="size" nzShape="round"
                                style="border-radius: 5px !important;" routerLink="../fellows">
                                <i nz-icon nzType="right"></i>
                                {{currentLabelsObj['View All']}}
                            </button>
                        </div>
                        <div class="hr_events">
                            <br>
                            <hr>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-lg-5">
                    <div class="section-title">
                        <h3 class="subheading skincolor h3_fellow res_Events"
                            style="color: #000;font-weight: 600;margin: 21px 0;">
                            {{currentLabelsObj['Events & Workshops']}}
                        </h3>
                    </div>
                    <div class="our-blog" style="padding:0px 10px">
                        <ng-container *ngFor="let item of eventsList.slice(0, 2); let i=index;let isLast=last">
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 no-padding event-wrapper ng-scope">
                                    <div class="row">
                                        <div class=" col-md-2 res_date" style="padding: 0;">
                                            <div class="event-time-wrapper">
                                                <span class="event-month"> {{item.Event_Start_Date|date:'MMM'}}</span>
                                                <span class="event-day">{{item.Event_Start_Date|date:'dd'}}</span>
                                                <span class="event-year">{{item.Event_Start_Date|date:'yyyy'}}</span>
                                            </div>
                                        </div>
                                        <div class=" col-md-10 res_contentSedu">
                                            <div class="event-content" style="padding-left: 10px;">
                                                <div class="event-name">
                                                    <img [src]="item.Image_Information.Image100">
                                                    <br>
                                                    <a [routerLink]="['/event',item.Event_URL]"><span>

                                                            {{item.Event_Title | slice:0:100}}
                                                            <!-- <span *ngIf="item.Post_Title.length>65">...</span> -->
                                                        </span></a>

                                                </div>
                                                <!-- {{item.Event_Address}} -->
                                                <span class="event-time" style="font-size: 13px;"> <i
                                                        style="color:#b72849" class="optico-icon-location-pin"></i>
                                                    {{item.Event_Address}}
                                                    <!-- {{item.Event_Address}} -->
                                                    <i class="fa fa-clock-o primary" style="color: #b73745;"></i>
                                                    {{item.Event_Start_Date|date:'hh : mm '}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <mat-divider *ngIf="!isLast" style="margin: 15px;"></mat-divider>
                        </ng-container>
                        <mat-divider style="margin: 15px;"></mat-divider>
                        <div class="viewallbtn">
                            <div class="button_icon" style="text-align: center; margin-top: 10px; ">
                                <button nz-button nzType="primary" [nzSize]="size" nzShape="round"
                                    style="border-radius: 5px !important;" routerLink="events">
                                    <i nz-icon nzType="right"></i>See All
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row res-fellow webViewal">
                <div class="col-md-7 col-lg-7 feature">
                    <div class="button_icon res_button" style="text-align: center;">
                        <button nz-button nzType="primary" [nzSize]="size" nzShape="round"
                            style="border-radius: 5px !important;" routerLink="../fellows">
                            <i nz-icon nzType="right"></i>
                            {{currentLabelsObj['View All']}}
                        </button>
                    </div>
                </div>
                <div class="col-md-5 col-lg-5">
                    <div class="button_icon" style="text-align: center;">
                        <button nz-button nzType="primary" [nzSize]="size" nzShape="round"
                            style="border-radius: 5px !important;" routerLink="events">
                            <i nz-icon nzType="right"></i>
                            {{currentLabelsObj['See All']}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="bg-lightgrey welcome-company " style="padding: 0px 0px 15px; background-color: #e4e4e4;">
        <div class="container resp-class">
            <div class="section-title">
                <h3 class="subheading skincolor h3_fellow" style="color: #000;font-weight: 600; text-align: center;">
                    <br>
                    {{currentLabelsObj['Our Impact']}}
                </h3>
            </div>
            <br />
            <div class="container" style="padding: 30px;
   background-color: #e4e4e4; border-radius: 10px;">
                <div class="row">
                    <div class="col-md-4 col-lg-4">
                        <h5 style="font-family: 'Poppins', sans-serif; font-weight: bold;">
                            {{currentLabelsObj['Pan India Reach']}}
                        </h5>
                        <br />
                        <div class="row">
                            <div class="col-sm-4 col-md-4">
                                <div class="we_img">
                                    <img src="assets/images/map.png" class="img-responsive"
                                        style="padding-left: 10px;" />
                                </div>
                            </div>
                            <div class="col-sm-5 col-md-5">
                                <!--<h1 class="nm">589</h1> -->
                                <h1 class="nm">705</h1>
                                <p>
                                    {{currentLabelsObj['Number of awards India Alliance has provided to National &
                                    International Researchers']}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4">
                        <h5 style="font-family: 'Poppins', sans-serif; font-weight: bold;">
                            {{currentLabelsObj['Forging Collaborations']}}
                        </h5>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                <div class="we_img">
                                    <img src="assets/images/hands.png" class="img-responsive" />
                                </div>
                            </div>
                            <div class="col-md-5">
                                <!-- <h1 class="nm">145</h1>-->
                                <h1 class="nm">263</h1>
                                <p>
                                    {{currentLabelsObj['National and International collaborative relationships
                                    enabled']}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4">
                        <h5 style="font-family: 'Poppins', sans-serif; font-weight: bold;">
                            {{currentLabelsObj['Building Capacity']}}
                        </h5>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                <div class="we_img">
                                    <img src="assets/images/home.png" class="img-responsive" />
                                </div>
                            </div>
                            <div class="col-md-5">
                                <!-- <h3>10</h3> -->
                                <h3>50</h3>
                                <p>
                                    {{currentLabelsObj['Programmes to build capacity in the biomedical and healthcare
                                    research ecosystem']}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- <section>
        <div class="row text-center">
            <div class="col-12">
                <div class="h3 class=" subheading skincolor h3_fellow
                    style="color: #000;font-weight: 600;margin-top: 50px">
                    {{currentLabelsObj['What People Say']}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10 offset-1" style="    margin-top: 25px;
    margin-bottom: 45px;">
                <div class="row" style="margin-left: 5%;">
                    <div style="margin-left: 3%;" *ngFor="let item of comments; let i=index">
                        <div>
                            <a *ngIf="i==3" (click)="onChangeDirection(item,-1)" style="padding-right: 5px;">
                                <i style="color: black;" nz-icon nzType="left" nzTheme="outline"></i>
                            </a>
                            <img [src]="item.image"
                                [ngStyle]="{height:i==0?'70px':i==1?'90px':i==2?'120px':i==3?'160px':i==4?'120px':i==5?'90px':'70px','border':i==3?'5px solid #b72847':'1px whitesmoke'}"
                                class="img-responsive" class="comments">
                            <a *ngIf="i==3" style="padding-left: 5px;" (click)="onChangeDirection(item,1)">
                                <i nz-icon nzType="right" style="color: black;" nzTheme="outline"></i>
                            </a> -->
    <!-- <p><b>{{item.}}</b></p> -->
    <!-- <p *ngIf="i==3"> {{item.comments}}</p> -->
    <!-- </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 offset-1 " style="margin-top: 25px; text-align: center;">
                        <span style="font-size: 16px;
          color: #000000;
          font-weight: 400;
         ">"
                            {{currentLabelsObj[selectedComment.comments]}}"
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 " style="margin-top: 15px;text-align: center;">
                        <span style="       font-size: 20px;
          color: #b72847;
          font-weight: 400;
          "><i>{{selectedComment.name}}</i></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 " style="text-align: center;">
                        <span style=" font-size: 20px;
        color: #000000;
        font-weight: 300;
        "><i>{{selectedComment.designation}}</i></span>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
</div>